var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckoutWhiteRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.761,
    height: 10.563,
    viewBox: "0 0 23.761 10.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "checkout_white_right_arrow",
    d: "M26.489,21.976H6.953a.953.953,0,1,1,0-1.906H26.521l-2.732-2.732a.862.862,0,0,1-.254-.635.944.944,0,0,1,1.62-.667l4.32,4.32a.968.968,0,0,1,.222.318.993.993,0,0,1,0,.7.968.968,0,0,1-.222.318l-4.32,4.32a.9.9,0,0,1-.683.3.959.959,0,0,1-.651-.3.932.932,0,0,1-.286-.683.882.882,0,0,1,.254-.651Z",
    transform: "translate(-6 -15.75)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutWhiteRightArrow);
export default __webpack_public_path__ + "static/media/checkout_white_right_arrow.9f8254ea6c84964e86a4b1b6b000de8b.svg";
export { ForwardRef as ReactComponent };